module.exports = __webpack_public_path__ + "media/images/static/movie/icon_close-fb37f112592a696fc4a1c92c8ed8c10c.png";